import { ESearchType } from '@/pages/workers/lm1-01/lm1-01.type';
import { insertObjectIf } from '@/utils';
import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import { omit } from 'ramda';
import { isNotNilOrEmpty } from 'ramda-adjunct';

import { formatMSelectLodgingPopupList } from './m-select-lodging-popup.helper';
import { MSelectLodgingPopupActions } from './m-select-lodging-popup.redux';
import { IPayloadGetMSelectLodgingPopupListRequest } from './m-select-lodging-popup.type';

export function* getMSelectLodgingPopupList(
	action: PayloadAction<IPayloadGetMSelectLodgingPopupListRequest>
) {
	const { callback, searchTypes, ...rest } = omit(['sortSql'], action.payload);

	try {
		const searchDistrict = searchTypes?.find(
			(item) => item.searchType === ESearchType.DISTRICT_ID
		);

		const otherSearchTypes = searchTypes?.find(
			(item) => item.searchType !== ESearchType.DISTRICT_ID
		);

		const params = {
			...insertObjectIf(isNotNilOrEmpty(searchDistrict), {
				districtId: searchDistrict?.searchValue,
			}),
			...insertObjectIf(isNotNilOrEmpty(otherSearchTypes), {
				searchType: otherSearchTypes?.searchType,
				searchValue: otherSearchTypes?.searchValue,
			}),
		};

		const res: API.ApiResponseSuccess<API.GetMSelectLodgingPopupListResponse> =
			yield API.getMSelectLodgingPopupList({ ...params, ...rest });

		const mSelectLodgingPopupList = formatMSelectLodgingPopupList(
			res?.data?.content
		);

		yield put(
			MSelectLodgingPopupActions.getMSelectLodgingPopupListSuccess({
				...rest,
				mSelectLodgingPopupList,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(MSelectLodgingPopupActions.getMSelectLodgingPopupListFailure());
	}
}
